import { gql } from '@config/graphqlClient';

const GET_PLATFORM_STATUS_DETAIL = gql`
  query PlatformStatusDetail {
    platformStatusDetail {
      overall
      sampledAt
      stale
      components {
        key
        name
        state
        description
        publicMessage
      }
      message {
        title
        body
        severity
        publishedAt
      }
      mobile {
        minimumSupportedVersion
      }
      dependencies {
        label
        status
        latencyMs
        error
      }
      metrics {
        client
        total
        errors
        errorRate
        windowMinutes
      }
      overrides {
        componentKey
        state
        publicMessage
        internalNote
        expiresAt
      }
    }
  }
`;

const SET_PLATFORM_STATUS_OVERRIDE = gql`
  mutation SetPlatformStatusOverride($input: PlatformStatusOverrideInput!) {
    setPlatformStatusOverride(input: $input) {
      overall
      sampledAt
    }
  }
`;

const CLEAR_PLATFORM_STATUS_OVERRIDE = gql`
  mutation ClearPlatformStatusOverride($componentKey: PlatformComponentKey!) {
    clearPlatformStatusOverride(componentKey: $componentKey)
  }
`;

const PUBLISH_PLATFORM_STATUS_MESSAGE = gql`
  mutation PublishPlatformStatusMessage($input: PlatformStatusMessageInput!) {
    publishPlatformStatusMessage(input: $input) {
      overall
      sampledAt
    }
  }
`;

const CLEAR_PLATFORM_STATUS_MESSAGE = gql`
  mutation ClearPlatformStatusMessage {
    clearPlatformStatusMessage
  }
`;

export const queries = {
  GET_PLATFORM_STATUS_DETAIL,
};

export const mutations = {
  SET_PLATFORM_STATUS_OVERRIDE,
  CLEAR_PLATFORM_STATUS_OVERRIDE,
  PUBLISH_PLATFORM_STATUS_MESSAGE,
  CLEAR_PLATFORM_STATUS_MESSAGE,
};
